// Central legal document configuration.
// Bump a version string here to require re-acceptance from all users.
// The text constants below are the single authoritative source for both
// the acceptance screen and the full-document views.

export const CURRENT_TERMS_VERSION   = '1.0';
export const CURRENT_PRIVACY_VERSION = '1.0';

export const TERMS_TEXT = `
TRUCKING SUBMISSION PRO
USER AGREEMENT / TERMS OF SERVICE
Version 1.0 — Effective October 5, 2026

PLEASE READ THIS AGREEMENT CAREFULLY BEFORE USING TRUCKING SUBMISSION PRO.

1. ACCEPTANCE OF TERMS

By accessing or using Trucking Submission Pro ("TSP," "the Service"), you agree to be bound by this User Agreement. If you do not agree to these terms, you may not use the Service.

2. DESCRIPTION OF SERVICE

Trucking Submission Pro is a commercial trucking insurance submission management platform operated by Processly ("Company"). The Service provides tools for managing insurance submissions, market evaluation, and placement intelligence for commercial trucking risks.

3. AUTHORIZED USE

Access to the Service is granted solely to authorized users of insurance agencies that have entered into a commercial agreement with Processly. You may use the Service only for lawful business purposes in connection with your role as a licensed insurance professional.

4. USER RESPONSIBILITIES

You are responsible for:
- Maintaining the confidentiality of your account credentials
- All activity that occurs under your account
- Ensuring that any information you enter is accurate and lawful
- Complying with all applicable laws, regulations, and professional licensing requirements
- Not sharing your account access with unauthorized individuals

5. PROHIBITED CONDUCT

You may not:
- Use the Service to process unauthorized, fraudulent, or illegal insurance submissions
- Attempt to gain unauthorized access to any part of the Service or its systems
- Reverse engineer, decompile, or disassemble any portion of the Service
- Use the Service in any manner that could damage, disable, or impair the Service
- Upload malware, viruses, or any other harmful code
- Violate any applicable law or regulation

6. INSURANCE DATA AND SUBMISSIONS

You acknowledge that:
- All submission data you enter is subject to applicable insurance regulations
- You are responsible for the accuracy and completeness of submission information
- The Service's market recommendations are informational tools only and do not constitute professional insurance advice
- Placement decisions remain entirely your professional responsibility

7. CONFIDENTIALITY

The Service contains proprietary market intelligence and underwriting data. You agree to:
- Keep all market appetite data, scoring criteria, and placement intelligence confidential
- Not disclose Service content to competitors or unauthorized third parties
- Use market data only for legitimate submission purposes within your agency

8. INTELLECTUAL PROPERTY

All content, features, and functionality of the Service, including market data, scoring algorithms, and platform technology, are owned by Processly and are protected by intellectual property laws. You receive a limited, non-exclusive, non-transferable license to use the Service for its intended purpose.

9. DATA ACCURACY DISCLAIMER

Market appetite information, eligibility rules, and carrier data within the Service are provided for informational purposes. Processly makes reasonable efforts to maintain accuracy but does not guarantee that all information is current, complete, or error-free. Always verify market appetite and submission requirements directly with carriers and underwriters.

10. LIMITATION OF LIABILITY

TO THE MAXIMUM EXTENT PERMITTED BY LAW, PROCESSLY SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE SERVICE. PROCESSLY'S TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNTS PAID BY YOUR AGENCY FOR THE SERVICE IN THE PRECEDING TWELVE MONTHS.

11. MODIFICATIONS TO THE SERVICE

Processly reserves the right to modify, suspend, or discontinue the Service at any time with reasonable notice. We also reserve the right to update these terms, in which case you will be required to accept the revised terms before continuing to use the Service.

12. TERMINATION

Processly may suspend or terminate your access to the Service for violation of these terms, at the request of your agency, or for any other lawful reason with reasonable notice.

13. GOVERNING LAW

This Agreement is governed by the laws of the State of Iowa, without regard to its conflict of law provisions.

14. CONTACT

Questions about these terms may be directed to: carter.proffitt@processlysystems.com

Processly
Iowa
`;

export const PRIVACY_TEXT = `
TRUCKING SUBMISSION PRO
PRIVACY POLICY
Version 1.0 — Effective October 5, 2026

1. OVERVIEW

This Privacy Policy describes how Processly ("we," "us," "our") collects, uses, and protects information in connection with Trucking Submission Pro ("TSP," "the Service"). We are committed to protecting the privacy of authorized users and the confidentiality of submission data.

2. INFORMATION WE COLLECT

a. Account Information
When your account is created, we collect: your name, username, email address (if provided), role, and the date your account was created.

b. Submission Data
Information you enter about insurance submissions, including company names, DOT numbers, equipment details, driver information, loss history, and related underwriting data.

c. Usage Information
We collect log data about your use of the Service, including login timestamps, actions performed, and technical information about your browser and device necessary for security and service operation.

d. Legal Acceptance Records
When you accept this Privacy Policy and the User Agreement, we record the version accepted, the timestamp of acceptance, your IP address, and your browser/device information. This record is maintained for legal and compliance purposes.

3. HOW WE USE YOUR INFORMATION

We use collected information to:
- Provide and maintain the Service
- Authenticate your identity and secure your account
- Maintain your submission records and work product
- Comply with legal obligations
- Investigate security incidents or policy violations
- Improve the Service

We do not sell your personal information to third parties.

4. SUBMISSION DATA OWNERSHIP

Submission data you enter belongs to your agency. Processly processes this data solely to provide the Service. If your agency's commercial agreement with Processly ends, your data will be handled according to that agreement's data retention and return provisions.

5. DATA SECURITY

We implement industry-standard security measures including:
- Encrypted data transmission (TLS)
- Hashed password storage (PBKDF2-SHA512)
- Session token authentication with automatic expiration
- Rate limiting on authentication endpoints
- Role-based access controls

No method of transmission or storage is 100% secure. We will notify you promptly in the event of a material security incident affecting your data.

6. DATA RETENTION

Account information and submission data are retained for the duration of your agency's relationship with Processly and as required by applicable law and your agency's data retention policies.

Legal acceptance records are retained indefinitely as required for legal compliance purposes.

7. THIRD-PARTY SERVICES

The Service uses the following third-party infrastructure:
- Vercel — hosting and serverless compute
- Upstash Redis — database storage
- Vercel Blob — document file storage
- Anthropic Claude — AI document analysis

Each provider maintains their own privacy and security standards. Document data sent to Anthropic for parsing is processed subject to Anthropic's zero-data-retention policy for API usage.

8. COOKIES AND LOCAL STORAGE

The Service uses browser localStorage to store your session token and cached submission data for performance purposes. No tracking cookies are used.

9. YOUR RIGHTS

Depending on applicable law, you may have the right to access, correct, or delete your personal information. Contact your agency administrator or Processly at carter.proffitt@processlysystems.com to submit a request.

10. CHANGES TO THIS POLICY

If we make material changes to this Privacy Policy, we will require you to review and acknowledge the updated policy before continuing to use the Service.

11. CONTACT

Privacy questions or requests: carter.proffitt@processlysystems.com

Processly
Iowa
`;
